
























import {Vue, Component, Prop } from "vue-property-decorator";
import CircleCountdown from "./components/CircleCountdown.vue";
import { Notice } from "./type/Notice";
import { declOfSum } from "@common/WordHelpers";

@Component({
    components: { CircleCountdown }
})
export default class ToastNotice extends Vue {
  @Prop({ required: true }) id: string;
  @Prop({ default: 5000 }) closeDelay: number;
  @Prop({ required: true }) source: Notice;
  @Prop({ default: 0 }) groupQuantity: number;

  showClose = true;

  mounted() {
    //выглядит как костыль, дважды $parent из-за transition-group
    this.$parent.$parent.$on('reset-counter', this.resetCounter);
  }

  resetCounter(id: string) {
    if(this.id === id && this.showClose) {
      const counter = this.$refs.counter as CircleCountdown;

      if(counter) {
        counter.reset()
      }
    }
  }

  get groupedMessage() {
    const moreQuantity = this.groupQuantity - 1;
    const titles = this.$t("common.groupedNotification.notifications")

    //checking need because type of TranslateResult is wrong
    if(Array.isArray(titles)) {
      const template = this.$t("common.groupedNotification.template", { quantity: moreQuantity, notification: declOfSum(moreQuantity, titles) }).toString()

      return this.groupQuantity > 1 ? `${this.source.text} + ${template.toLowerCase()}` : this.source.text
    }

    return this.source.text;
  }

  get classNames() {

    const colorClass = `toast-notice_${this.source.level}`

    return [colorClass];
  }
}
